import { identityAccountId, IdentityAccountId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class IAMAccountCredentialsUpdateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountCredentialsUpdateRequestDTO.validationSchema()
  );

  constructor(readonly data: IAMAccountCredentialsUpdateRequestDTORaw) {
    JsonSchemaValidator.validate(
      IAMAccountCredentialsUpdateRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["accountId"],
      properties: {
        accountId: identityAccountId
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountCredentialsUpdateRequestDTORaw {
  accountId: IdentityAccountId;
}
